/**
 * VIP staking deposit indices that are stuck on-chain and must be force-hidden
 * from the claim/withdraw flow.
 *
 * Why: period-7 VIP deposits on the mainnet VIP contract
 * STUCK_VIP_CONTRACT_ADDRESS revert when claim/withdraw is attempted, and
 * claimAll() on those wallets reverts the whole batch.

 */
export const STUCK_VIP_NETWORK_ID = '137';
export const STUCK_VIP_CONTRACT_ADDRESS = '0xa816fc819c2bd73c0aedf60e0b06daf2bff9691f';

const STUCK_VIP_DEPOSITS_RAW: Record<string, number[]> = {
  '0xce043a2c3572c111fc3e2e660600c6f83f98cc74': [11],
  '0x5eff5eb03d495904cb1fc318e3fdf91f56b68295': [8],
  '0x47cabba9abf3ff8a9dde2ac3675ab6e029c652c9': [11, 12],
  '0x06f860b593e509e3ff0617859418d2f99495ea81': [7],
  '0x2eb52d6c72919246d7370e16267f9dde7cdcfcaa': [14],
  '0x986b088f2874fec553f05644aa22c4b0239d54e5': [24],
  '0x2cb558577ba4c70752f65b71188e6563e725e0a5': [5],
  '0xf7e482d5e2a72ca9e1e17945192a83e81f4bfe71': [26],
  '0xb322de242318f10b70959acfc676e7a9e6056482': [22],
  '0x66e7315e8470cfdce48059882ebb867fd19920f6': [14, 15, 16, 17, 18],
  '0xe9ce9be409e683a3a867a3a6581053f0ddab4ca4': [18, 19],
  '0xdcc62cf1e7c6a242ed3f866faefbe8aeb87b28ec': [14, 15],
  '0xf3cf2184d03b480aceee416342446503dfcdca19': [6],
  '0xffd77ff7b9f30e120071187ee9cb1bdd87b0d891': [3],
  '0xf78411993c25c051f8f5678c80dcce54cce8519d': [6],
  '0x20a8702b0626ca89c961de94f7f3f1da3dde1a2e': [8],
  '0x808d2acf6ea6736d5c97e3b9167bcf630f4d583d': [9],
  '0xbe4528fbeeb821bc3e9697283a35f6c0808e30af': [9],
  '0x3dfbc5a761aeaf5d77dd8115453a96ad0c381fa5': [9],
  '0x664a006af27911f4d12a665c32b579c9509a1eeb': [9],
  '0xb9b089b16491264296fbb7c068ca73e8e61d6612': [9],
  '0xb22640a2a4f0c7e552e4289b826a349599e0937c': [10],
  '0x9b2da3bb545909ad7406c99f0eacf81be3b244b9': [9],
  '0xf4d7441c4d2118942f7fb36d55cbc6a9bab693d8': [9],
  '0xc99b9d4bbb924e3dec23db4a65cadd250845e8db': [9],
  '0xd2fb4a17fbf9016258ebff090bce3f9b6eb49116': [9],
  '0xf121408daa6edf4db5f67d8adbf9eaf5293569cd': [14, 15, 16, 17, 18],
  '0xdbd875e570bae83e23fc68fce1aec7d63cec4ada': [9],
  '0x3042bf2b6c2001f92b3583c5415d9ca12acf475b': [4],
  '0xc4bb67a5361f1976c6327252a1ec21d2f1555f5b': [1],
  '0x8a02d0809c7ff6749c4728c811e9c1f2d0351d2f': [7, 8],
  '0x412f30d40cd80c4d6a175bdb07695978605bf247': [7],
  '0xe52387a28ab7db9882b3046ce3abc5855a7425f4': [5],
  '0x4be3275fb70805698450e7c5ea29ca7cab732837': [8],
  '0x24339502739640eb4dfabfab7f0ef3314ddc9c60': [1],
  '0x840cfdb0b6d47dbbe215202a9d1fb9a165b734bf': [11],
  '0xf01040a392a63f211a99de380d5c1b665320a863': [12],
  '0xa7d79178942235a34a33e25c379a635a41400f2c': [16],
  '0xd5851b50855de755fb34c803a862b55423019fa9': [5],
  '0x4a8b16e99689c6f1d55b922eeb1806327c1c9d3d': [8],
  '0x9e618986a6513ee8fd67ded0dd6d18bb17d1bd97': [7],
  '0xcbcb8439a22a01847757ceb784016083cb6a0f65': [8],
  '0xa339b415398928f2c48c19f90b8e2804d7d29ecf': [5],
  '0x0866f421d2591b87f459b7373d2fa9f8f959b7d7': [5],
  '0x2329023ef31cfe7a84e9f53f15dfbcfac3aacf5a': [9],
  '0xe2030d09d8682e2771f9d179bd1a61366245d2ce': [3],
  '0xd83f2e7768bbe2eaf597f54bd03ea81a9596870f': [24],
  '0x2d4c79960bce4161643e0f3a7b7c459f876bdee6': [12],
  '0xa77a6701186402f251d342af9c73eb9c7f81b0b1': [7],
  '0xd00be684871aae5e22042fe68dad498eb3811a3e': [7],
  '0x2ee2405dc72ea46bcebddbc089bc11897c86935d': [4],
  '0x5acd7734fa4e93854f4459f7eeea99d7ddff8734': [4, 5],
  '0x243fa6718905084b07c5ff665d34cec0bb57df60': [6],
  '0xb513e2adfb16c1e6f8f92d7ba2533826c5fd4361': [7],
  '0x3aaf48118cae0f66a8738c24d04e260728a186c7': [10],
  '0x247e8465d56972b09de579c13ed40792a09bc278': [5],
  '0xff3a58211068937e42fb2a580ccb5ba1540d6c7f': [4],
  '0xee8c8371b5e72447e664a31dc8acc32875c0a4ad': [1],
  '0xbdcd9aa0ba209b4db573d846d40515af9a18dc46': [0],
  '0x831094c075744fe564031f33a672d52b7cc07d23': [0],
  '0x57a1bd324391ce1ac3a338cf7e1fd672ccafa46b': [0],
  '0x2d959946536408f3a5447e872fc3df00bad85097': [0],
  '0x4d307a6e63486d01b95b691fbd1ee703b07db259': [0],
  '0x99dd14b704c246da813f9589e7cd53f3b8d00010': [2],
  '0x6148b13d0aeed932056469587f583c389f01a04b': [3],
  '0xabd38386034c07ffbd37d87080f4deccd7bac245': [3],
  '0x8dfced54d2f84a53774d0d5974f3d5e81d4a5f78': [3],
  '0x0a6c8b37acff745c89c1e9bb46f45e930ffd36fe': [0],
  '0x4b78afc593d70bf168c0871129524014e274c5cf': [1],
  '0x3fcf6ebece3aa8b5e8a44859a20ce817ff4e241c': [3],
  '0x90ab90be2ce0df9a0bc3a75684d19baa48e3354e': [0],
};

const STUCK_VIP_DEPOSITS: Map<string, Set<number>> = new Map(
  Object.entries(STUCK_VIP_DEPOSITS_RAW).map(([address, indices]) => [address, new Set(indices)])
);

const matchesStuckNetwork = (
  networkId: string | number | null | undefined,
  vipContractAddress: string | null | undefined
): boolean => {
  if (networkId === null || networkId === undefined) return false;
  if (!vipContractAddress) return false;
  if (String(networkId) !== STUCK_VIP_NETWORK_ID) return false;
  return vipContractAddress.toLowerCase() === STUCK_VIP_CONTRACT_ADDRESS;
};

/**
 * Returns true if the given (wallet, on-chain deposit index) pair is stuck
 * and should be treated as already claimed.
 */
export const isStuckVipDeposit = (
  walletAddress: string | null | undefined,
  depositIndex: number,
  networkId: string | number | null | undefined,
  vipContractAddress: string | null | undefined
): boolean => {
  if (!walletAddress) return false;
  if (!matchesStuckNetwork(networkId, vipContractAddress)) return false;
  const indices = STUCK_VIP_DEPOSITS.get(walletAddress.toLowerCase());
  return indices ? indices.has(depositIndex) : false;
};

/**
 * Returns true if the wallet has any stuck VIP deposits. Used to suppress
 * the "Claim All" button (which would otherwise revert on-chain).
 */
export const hasStuckVipDeposits = (
  walletAddress: string | null | undefined,
  networkId: string | number | null | undefined,
  vipContractAddress: string | null | undefined
): boolean => {
  if (!walletAddress) return false;
  if (!matchesStuckNetwork(networkId, vipContractAddress)) return false;
  return STUCK_VIP_DEPOSITS.has(walletAddress.toLowerCase());
};
